import React, { useEffect, useState } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../../../services/back.service';
import LoadingSpinner from '../../../shared/loaderSpinner';
import useAutosave from '../../../../hooks/useAutosave';

function FormCompBottomMoto({ id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  // GUARDA CADENA - chain_guard -> Axle_Dust_Covers
  // KIT DE ARRASTRE - drag_kit -> Axial_Dust_Covers
  // PROTECTOR DE MOTOR - engine_protector -> Scissors
  // EXHOSTO - exhost -> Scissor_Bushings
  // RODAMIENTOS - bearings -> Stabilizer_Bar_Bushings
  // CUNAS - cradles -> Stabilizer_bar
  const [infoBottomComponent, setInfoCompBottom] = useState({
    chain_guard: 0,
    drag_kit: 0,
    engine_protector: 0,
    exhost: 0,
    bearings: 0,
    cradles: 0,
  });
  const [states, setStates] = useState([]);

  const autosave = useAutosave(async () => {
    await post('/peritaje/modifyinspection/components/' + id, { type: 'BC', data: infoBottomComponent });
  });

  const handleForm = ({ target }) => {
    const tmpBottomComponent = { ...infoBottomComponent, [target.name]: target.value }
    setInfoCompBottom(tmpBottomComponent);
    autosave.schedule();
  };

  const getInfoState = async () => { //infostate
    const respoInfo = await get(`/peritaje/infostate/C`, {});
    if (respoInfo.success) {
      const { stateapp } = respoInfo.data;
      const currentDefaultState = stateapp.find((e) => e.name.toLowerCase() === 'bueno')
      setInfoCompBottom({
        chain_guard: currentDefaultState.id,
        drag_kit: currentDefaultState.id,
        engine_protector: currentDefaultState.id,
        exhost: currentDefaultState.id,
        bearings: currentDefaultState.id,
        cradles: currentDefaultState.id,
      })
      setStates(stateapp);
    } else {
      console.log(respoInfo.message);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const body = { type: 'BC', data: infoBottomComponent };
    const respo = await post('/peritaje/modifyinspection/components/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };

  useEffect(() => {
    const initForm = async () => {
      setIsLoading(true);
      const body = { type: 'BC' };
      const tmpBottom = {};
      const respo = await post(
        '/peritaje/infodetailinspection/components/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        for (let i = 0; i < detail.length; i++) {
          const element = detail[i];
          tmpBottom[element.name] = element.id_state;
        }
        if (detail.length > 0) setInfoCompBottom(tmpBottom);
      }
      setIsLoading(false);
    };
    getInfoState();
    initForm();
  }, [id]);

  return (isLoading) ? <LoadingSpinner /> : (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">COMPONENTES INFERIORES</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="chain_guard">Guarda Cadena</Form.Label>
          <Form.Select
            name="chain_guard"
            value={infoBottomComponent.chain_guard}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="drag_kit">Kit de arrastre</Form.Label>
          <Form.Select
            name="drag_kit"
            value={infoBottomComponent.drag_kit}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="engine_protector">Protector de motor</Form.Label>
          <Form.Select
            name="engine_protector"
            value={infoBottomComponent.engine_protector}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="exhost">Exhosto</Form.Label>
          <Form.Select
            name="exhost"
            value={infoBottomComponent.exhost}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="bearings">Rodamientos</Form.Label>
          <Form.Select
            name="bearings"
            value={infoBottomComponent.bearings}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
        <Col xs={12} md={6}>
          <Form.Label htmlFor="cradles">Cunas</Form.Label>
          <Form.Select
            name="cradles"
            value={infoBottomComponent.cradles}
            onChange={(e) => handleForm(e)}
            aria-label="Default select example"
          >
            <option value={0}>Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormCompBottomMoto;
